module.exports = {"433173002":"湖南永顺经济开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433173.json
// module id = 1944
// module chunks = 0